import {
  DateRangeOperator,
  FilterConfigType,
  FilterInputEnum,
  FilterOperatorEnums
} from '@providers/types-provider';
import { DateRangePickerOperators, Step } from '@ui-components/table-filters';

export const NewTableFilterConfig: FilterConfigType[] = [
  {
    key: 'workflowType',
    displayName: 'Workflow Type',
    operator: {
      value: FilterOperatorEnums.INCLUDES,
      type: FilterInputEnum.SELECT,
      options: [
        { displayName: FilterOperatorEnums.INCLUDES, key: FilterOperatorEnums.INCLUDES },
        { displayName: FilterOperatorEnums.EXCLUDES, key: FilterOperatorEnums.EXCLUDES }
      ]
    },
    value: {
      type: FilterInputEnum.MULTI_VALUE_SELECT,
      defaultValue: [],
      optionRenderer: (text: string) => {
        if (text === 'COPY_WORKFLOW') {
          return 'Copy';
        } else if (text === 'workflowType') {
          return 'Workflow Type';
        } else {
          return text
            .toLowerCase()
            .split('_')
            .map((token: string) => token[0].toUpperCase() + token.substring(1))
            .join(' ');
        }
      }
    }
  },
  {
    key: 'assigneeName',
    displayName: 'Assignee',
    operator: {
      value: FilterOperatorEnums.INCLUDES,
      type: FilterInputEnum.SELECT,
      options: [
        { displayName: FilterOperatorEnums.INCLUDES, key: FilterOperatorEnums.INCLUDES },
        { displayName: FilterOperatorEnums.EXCLUDES, key: FilterOperatorEnums.EXCLUDES }
      ]
    },
    value: {
      type: FilterInputEnum.MULTI_VALUE_SELECT,
      defaultValue: []
    }
  },
  {
    key: 'contentType',
    displayName: 'Content Type',
    operator: {
      value: FilterOperatorEnums.INCLUDES,
      type: FilterInputEnum.SELECT,
      options: [
        { displayName: FilterOperatorEnums.INCLUDES, key: FilterOperatorEnums.INCLUDES },
        { displayName: FilterOperatorEnums.EXCLUDES, key: FilterOperatorEnums.EXCLUDES }
      ]
    },
    value: {
      type: FilterInputEnum.MULTI_VALUE_SELECT,
      defaultValue: []
    }
  },
  {
    key: 'taskDri',
    displayName: 'Task DRI',
    operator: {
      value: FilterOperatorEnums.INCLUDES,
      type: FilterInputEnum.SELECT,
      options: [
        { displayName: FilterOperatorEnums.INCLUDES, key: FilterOperatorEnums.INCLUDES },
        { displayName: FilterOperatorEnums.EXCLUDES, key: FilterOperatorEnums.EXCLUDES }
      ]
    },
    value: {
      type: FilterInputEnum.MULTI_VALUE_SELECT,
      defaultValue: []
    }
  },
  {
    key: 'locale',
    displayName: 'Locale',
    operator: {
      value: FilterOperatorEnums.INCLUDES_ANY,
      type: FilterInputEnum.SELECT,
      options: [
        { displayName: FilterOperatorEnums.INCLUDES_ANY, key: FilterOperatorEnums.INCLUDES_ANY },
        { displayName: FilterOperatorEnums.EXCLUDES, key: FilterOperatorEnums.EXCLUDES }
      ]
    },
    value: {
      type: FilterInputEnum.MULTI_VALUE_SELECT,
      defaultValue: []
    }
  },
  {
    key: 'genres',
    displayName: 'Genre',
    operator: {
      value: FilterOperatorEnums.INCLUDES_ANY,
      type: FilterInputEnum.SELECT,
      options: [
        { displayName: FilterOperatorEnums.INCLUDES_ANY, key: FilterOperatorEnums.INCLUDES_ANY },
        { displayName: FilterOperatorEnums.EXCLUDES, key: FilterOperatorEnums.EXCLUDES }
      ]
    },
    value: {
      type: FilterInputEnum.MULTI_VALUE_SELECT,
      options: [],
      defaultValue: []
    }
  },
  {
    key: 'taskStatus',
    displayName: 'Task Status',
    operator: {
      value: FilterOperatorEnums.IS,
      type: FilterInputEnum.SELECT,
      options: [
        { displayName: FilterOperatorEnums.IS, key: FilterOperatorEnums.IS },
        { displayName: FilterOperatorEnums.INCLUDES, key: FilterOperatorEnums.INCLUDES },
        { displayName: FilterOperatorEnums.EXCLUDES, key: FilterOperatorEnums.EXCLUDES }
      ]
    },
    value: {
      type: FilterInputEnum.MULTI_VALUE_SELECT,
      defaultValue: [],
      optionRenderer: (text: string) => {
        return text
          .split('_')
          .map((token: string) => {
            return token.charAt(0).toUpperCase() + token.substring(1).toLowerCase();
          })
          .join(' ');
      }
    }
  },
  {
    key: 'state',
    displayName: 'Task State',
    operator: {
      value: FilterOperatorEnums.INCLUDES,
      type: FilterInputEnum.SELECT,
      options: [
        { displayName: FilterOperatorEnums.INCLUDES, key: FilterOperatorEnums.INCLUDES },
        { displayName: FilterOperatorEnums.EXCLUDES, key: FilterOperatorEnums.EXCLUDES }
      ]
    },
    value: {
      type: FilterInputEnum.MULTI_VALUE_SELECT,
      defaultValue: [],
      optionRenderer: (text: string) => {
        return text
          .split('_')
          .map((token: string) => {
            return token.charAt(0).toUpperCase() + token.substring(1).toLowerCase();
          })
          .join(' ');
      }
    }
  },
  {
    key: 'dueDate',
    displayName: 'Due Date',
    operator: {
      value: DateRangeOperator.ThisYear,
      type: FilterInputEnum.SELECT,
      options: DateRangePickerOperators
    },
    value: {
      type: FilterInputEnum.DATE,
      options: {
        gt: new Date(new Date().getFullYear(), 0, 1),
        lt: new Date(new Date().getFullYear() + 1, 0, 1)
      }
    }
  },
  {
    key: 'updatedAt',
    displayName: 'Updated At',
    operator: {
      value: DateRangeOperator.ThisYear,
      type: FilterInputEnum.SELECT,
      options: DateRangePickerOperators
    },
    value: {
      type: FilterInputEnum.DATE,
      options: {
        gt: new Date(new Date().getFullYear(), 0, 1),
        lt: new Date(new Date().getFullYear() + 1, 0, 1)
      }
    }
  },
  {
    key: 'statusUpdatedAt',
    displayName: 'Status Updated At',
    operator: {
      value: DateRangeOperator.ThisYear,
      type: FilterInputEnum.SELECT,
      options: DateRangePickerOperators
    },
    value: {
      type: FilterInputEnum.DATE,
      options: {
        gt: new Date(new Date().getFullYear(), 0, 1),
        lt: new Date(new Date().getFullYear() + 1, 0, 1)
      }
    }
  },
  {
    key: 'createdAt',
    displayName: 'Created At',
    operator: {
      value: DateRangeOperator.ThisYear,
      type: FilterInputEnum.SELECT,
      options: DateRangePickerOperators
    },
    value: {
      type: FilterInputEnum.DATE,
      options: {
        gt: new Date(new Date().getFullYear(), 0, 1),
        lt: new Date(new Date().getFullYear() + 1, 0, 1)
      }
    }
  },
  {
    key: 'confidential',
    displayName: 'Confidential',
    operator: {
      value: FilterOperatorEnums.IS,
      type: FilterInputEnum.VALUE
    },
    value: {
      type: FilterInputEnum.SELECT,
      optionRenderer: (text: string) => {
        return text.charAt(0).toUpperCase() + text.slice(1);
      }
    }
  },
  {
    key: 'priority',
    displayName: 'Priority',
    operator: {
      value: FilterOperatorEnums.IS,
      type: FilterInputEnum.VALUE
    },
    value: {
      type: FilterInputEnum.SELECT,
      options: [
        { displayName: 'True', key: 'true' },
        { displayName: 'False', key: 'false' }
      ]
    }
  },
  {
    key: 'adaptationFlow',
    displayName: 'Adaptation Flow',
    operator: {
      value: FilterOperatorEnums.IS,
      type: FilterInputEnum.VALUE
    },
    value: {
      type: FilterInputEnum.SELECT,
      options: [
        { displayName: 'True', key: 'true' },
        { displayName: 'False', key: 'false' }
      ]
    }
  },
  {
    key: 'title',
    displayName: 'Task Title',
    operator: {
      value: FilterOperatorEnums.IS,
      options: [
        {
          displayName: FilterOperatorEnums.IS,
          key: FilterOperatorEnums.IS
        },
        {
          displayName: FilterOperatorEnums.INCLUDES,
          key: FilterOperatorEnums.INCLUDES
        },
        {
          displayName: FilterOperatorEnums.NOT_CONTAINS,
          key: FilterOperatorEnums.NOT_CONTAINS
        }
      ],
      type: FilterInputEnum.SELECT
    },
    value: {
      type: FilterInputEnum.INPUT,
      defaultValue: ''
    }
  },
  {
    key: 'revision_round_integer',
    displayName: 'Revision',
    operator: {
      value: FilterOperatorEnums.INCLUDES,
      type: FilterInputEnum.VALUE
    },
    value: {
      type: FilterInputEnum.MULTI_VALUE_SELECT,
      defaultValue: []
    }
  },
  {
    key: 'backstage_task_id_text_general',
    displayName: 'ID',
    operator: {
      value: FilterOperatorEnums.INCLUDES,
      type: FilterInputEnum.VALUE
    },
    value: {
      type: FilterInputEnum.MULTIPLE_INPUT,
      defaultValue: []
    }
  },
  {
    key: 'classifier_text_general',
    displayName: 'Classifier',
    operator: {
      value: FilterOperatorEnums.INCLUDES,
      type: FilterInputEnum.SELECT,
      options: [
        {
          displayName: FilterOperatorEnums.INCLUDES_ALL,
          key: FilterOperatorEnums.INCLUDES_ALL
        },
        {
          displayName: FilterOperatorEnums.INCLUDES,
          key: FilterOperatorEnums.INCLUDES
        }
      ]
    },
    value: {
      type: FilterInputEnum.MULTI_VALUE_SELECT,
      defaultValue: []
    }
  },
  {
    key: 'keyword_text_general',
    displayName: 'Keyword',
    operator: {
      value: FilterOperatorEnums.INCLUDES,
      type: FilterInputEnum.VALUE
    },
    value: {
      type: FilterInputEnum.MULTI_VALUE_SELECT,
      defaultValue: []
    }
  },
  {
    key: 'lob_text_full_match',
    displayName: 'LOB',
    operator: {
      value: FilterOperatorEnums.INCLUDES,
      type: FilterInputEnum.VALUE
    },
    value: {
      type: FilterInputEnum.MULTI_VALUE_SELECT,
      defaultValue: []
    }
  },
  {
    key: 'project_text_general',
    displayName: 'Project',
    operator: {
      value: FilterOperatorEnums.INCLUDES,
      type: FilterInputEnum.VALUE
    },
    value: {
      type: FilterInputEnum.MULTI_VALUE_SELECT,
      defaultValue: []
    }
  },
  {
    key: 'request_type_text_general',
    displayName: 'Request Type',
    operator: {
      value: FilterOperatorEnums.INCLUDES,
      type: FilterInputEnum.VALUE
    },
    value: {
      type: FilterInputEnum.MULTI_VALUE_SELECT,
      defaultValue: []
    }
  },
  {
    key: 'workflowId',
    displayName: 'Workflow ID',
    operator: {
      value: FilterOperatorEnums.INCLUDES_ANY,
      options: [
        {
          displayName: FilterOperatorEnums.INCLUDES_ANY,
          key: FilterOperatorEnums.INCLUDES_ANY
        },
        {
          displayName: FilterOperatorEnums.EXCLUDES,
          key: FilterOperatorEnums.EXCLUDES
        }
      ],
      type: FilterInputEnum.SELECT
    },
    value: {
      type: FilterInputEnum.MULTIPLE_INPUT,
      defaultValue: [],
      validator: new RegExp(/.{8}-.{4}-.{4}-.{4}-.{12}/)
    }
  },
  {
    key: 'taskId',
    displayName: 'Task ID',
    operator: {
      value: FilterOperatorEnums.INCLUDES_ANY,
      options: [
        {
          displayName: FilterOperatorEnums.INCLUDES_ANY,
          key: FilterOperatorEnums.INCLUDES_ANY
        },
        {
          displayName: FilterOperatorEnums.EXCLUDES,
          key: FilterOperatorEnums.EXCLUDES
        }
      ],
      type: FilterInputEnum.SELECT
    },
    value: {
      type: FilterInputEnum.MULTIPLE_INPUT,
      defaultValue: []
    }
  },
  {
    key: 'iso3aCountryCodes',
    displayName: 'Storefront',
    operator: {
      value: FilterOperatorEnums.INCLUDES_ANY,
      options: [
        {
          displayName: FilterOperatorEnums.INCLUDES_ANY,
          key: FilterOperatorEnums.INCLUDES_ANY
        },
        {
          displayName: FilterOperatorEnums.EXCLUDES,
          key: FilterOperatorEnums.EXCLUDES
        }
      ],
      type: FilterInputEnum.SELECT
    },
    value: {
      type: FilterInputEnum.MULTI_VALUE_SELECT,
      defaultValue: []
    }
  },
  {
    key: 'isRead_bool',
    displayName: 'Read Status',
    devEnabledOnly: ['localhost', 'itms7'],
    operator: {
      value: FilterOperatorEnums.IS,
      type: FilterInputEnum.VALUE
    },
    value: {
      type: FilterInputEnum.SELECT,
      options: [
        { displayName: 'True', key: 'true' },
        { displayName: 'False', key: 'false' }
      ]
    }
  },
  {
    key: 'placementTypes_text_full_match',
    displayName: 'Placement Type',
    operator: {
      value: FilterOperatorEnums.INCLUDES_ANY,
      options: [
        {
          displayName: FilterOperatorEnums.INCLUDES_ANY,
          key: FilterOperatorEnums.INCLUDES_ANY
        },
        {
          displayName: FilterOperatorEnums.EXCLUDES,
          key: FilterOperatorEnums.EXCLUDES
        }
      ],
      type: FilterInputEnum.SELECT
    },
    value: {
      type: FilterInputEnum.MULTI_VALUE_SELECT,
      defaultValue: []
    }
  },
  {
    key: 'step',
    displayName: 'Step',
    operator: {
      value: FilterOperatorEnums.INCLUDES,
      type: FilterInputEnum.SELECT,
      options: [
        { displayName: FilterOperatorEnums.INCLUDES, key: FilterOperatorEnums.INCLUDES },
        { displayName: FilterOperatorEnums.EXCLUDES, key: FilterOperatorEnums.EXCLUDES }
      ]
    },
    value: {
      type: FilterInputEnum.MULTI_VALUE_SELECT,
      options: [
        { displayName: 'Writer', key: Step.WRITER },
        { displayName: 'Editor', key: Step.EDITOR },
        { displayName: 'Reviewer', key: Step.REVIEWER },
        { displayName: 'Language Manager', key: Step.LANGUAGE_MANAGER },
        { displayName: 'Producer', key: Step.PRODUCER },
        { displayName: 'Business', key: Step.BUSINESS }
      ],
      defaultValue: []
    }
  }
];
